// noinspection JSIgnoredPromiseFromCall

export default function handleAjaxError(error, form = null) {
	// Default function for handling an ajax error, displays a sweet alert popup with the error.
	const MAX_PARENT_TRAVERSAL_FOR_FEEDBACK = 5;

	// If jquery response
	const response = error;
	// noinspection JSUnresolvedVariable,EqualityComparisonWithCoercionJS
	if (response.responseJSON && response.responseJSON.errors != undefined && form) {
		$.each(response.responseJSON.errors, function (k, v) {
			if (form.find('#' + k).length) {
				// noinspection JSCheckFunctionSignatures
				form.find('#' + k).addClass('is-invalid').parents('.form-group')
					.find('.invalid-feedback').text(v.join('. '));

				const element = form.find('#' + k)[0];
				window.scrollToElementNative(element);

			} else {
				// Try finding as an input array

				const isArray = k.includes('.');
				if (isArray) {
					const inputArrayName = k.split('.')[0];
					const index = k.split('.')[1];

					form.find(getSelectorForArrayFieldsByPartialMatch(inputArrayName)).each((_index, element) => {
						// noinspection EqualityComparisonWithCoercionJS
						if (index == _index) {
							// noinspection JSCheckFunctionSignatures
							$(element).addClass('is-invalid').parents('.form-group')
								.find('.invalid-feedback').text(v.join('. ').replace(k, inputArrayName));

							window.scrollToElementNative(element);
						}
					})

				} else {
					// noinspection JSUnresolvedVariable
					Swal.fire({
						icon: 'error',
						text: v[0],
					});
				}
			}
		})
	} else if (response.responseJSON && response.responseJSON.message) {
		// noinspection EqualityComparisonWithCoercionJS,PointlessBooleanExpressionJS,JSUnresolvedVariable
		Swal.fire({
			icon: 'error',
			text: (response.responseJSON.message != undefined) ? response.responseJSON.message : 'Oops something went wrong, please try again'
		});
	}

	// If normal response
	else if (error.response) {
		// The request was made and the server responded with a status code
		// that falls out of the range of 2xx
		if (error.response.data.errors && Object.values(error.response.data.errors)[0] && Object.values(error.response.data.errors)[0][0]) {

			// Look for fields with name for errors
			let fieldFound = false;
			Object.keys(error.response.data.errors).forEach(field => {
				const mayBeArray = field.split('.')[1];

				const errors = error.response.data.errors[field];
				let container = document;
				if (form) {
					container = form;
				}
				if (mayBeArray && field.match(/\.?(\d+)\./)) {
					// Assume array
					const index = field.match(/\.?(\d+)\./)[1];
					const actualField = field.match(/\.([^.]*)$/)[1];


					// noinspection EqualityComparisonWithCoercionJS
					container.querySelectorAll(getSelectorForSimpleFields(actualField)).forEach((fieldElement, _index) => {
						// noinspection EqualityComparisonWithCoercionJS
						if (_index == index) {
							displayFeedback(fieldElement, errors[0])

							window.scrollToElementNative(fieldElement);

							fieldFound = true;
						}
					});

				} else if (mayBeArray && field.match(/\.?(\d+)/)) {
					// Assume simple array with form 'field[]'

					const index = field.match(/\.?(\d+)/)[1];
					const actualField = field.match(/([^.]*)\./)[1];

					container.querySelectorAll(getSelectorForArrayFields(actualField)).forEach((fieldElement, _index) => {
						// noinspection EqualityComparisonWithCoercionJS
						if (_index == index) {
							// Attempt to fix field name if needed
							let error = errors[0];
							error = error.replace(field, actualField);
							displayFeedback(fieldElement, error)

							window.scrollToElementNative(fieldElement);

							fieldFound = true;
						}
					});
				} else {
					console.log('searching', getSelectorForSimpleFields(field))
					container.querySelectorAll(getSelectorForSimpleFields(field)).forEach((fieldElement, _index) => {
						displayFeedback(fieldElement, errors[0]);
						window.scrollToElementNative(fieldElement);
						fieldFound = true;
					});
				}
			})
			if (!fieldFound) {
				// noinspection JSUnresolvedVariable
				Swal.fire({
					icon: 'error',
					text: Object.values(error.response.data.errors)[0][0], // First error of the first field
				})
			}
		} else {
			// noinspection JSUnresolvedVariable
			if (error.response.data.extendedError) {
				displayExtendedErrorMessage(error);
			} else if (error.response.data.message) {
				// noinspection JSUnresolvedVariable
				Swal.fire({
					icon: 'error',
					text: error.response.data.message, // First error of the first field
				})
			} else if (error.response.data.error) {
				// noinspection JSUnresolvedVariable
				Swal.fire({
					icon: 'error',
					text: error.response.data.error, // First error of the first field
				})
			} else {
				// noinspection JSUnresolvedVariable
				Swal.fire({
					icon: 'error',
					text: "Something went wrong, please try again later",
				})
			}
		}
		console.log(error.response);
	} else if (error.request) {
		// The request was made but no response was received
		// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
		// http.ClientRequest in node.js
		// noinspection JSUnresolvedVariable
		Swal.fire({
			icon: 'error',
			text: "Something went wrong, please try again later",
		})
		console.log(error.request);
	} else {
		// Something happened in setting up the request that triggered an Error
		// noinspection JSUnresolvedVariable
		Swal.fire({
			icon: 'error',
			text: "Something went wrong, please try again later",
		})
		console.log('Error', error.message);
		console.error(error);
	}

	/**
	 * Methods
	 */

	function getSelectorForSimpleFields(field) {
		return `input[name="${field}"],select[name="${field}"],textarea[name="${field}"]`;
	}

	function getSelectorForArrayFields(field) {
		return `input[name="${field}[]"],select[name="${field}[]"],textarea[name="${field}[]"]`;
	}

	function getSelectorForArrayFieldsByPartialMatch(field) {
		return `input[name^="${field}"],select[name^="${field}"],textarea[name^="${field}"]`;
	}

	/**
	 *
	 * @param {Element} element
	 * @param {string} feedback
	 */
	function displayFeedback(element, feedback) {
		element.classList.add('is-invalid');

		// Search for feedback container
		let parentsTraversed = 1
		while (element.parentElement) {
			if (parentsTraversed > MAX_PARENT_TRAVERSAL_FOR_FEEDBACK) {
				break;
			}
			const feedbackContainer = element.parentElement.querySelector('.invalid-feedback');

			if (feedbackContainer) {
				feedbackContainer.innerText = feedback;

				// Make visible if not on the same container as input
				feedbackContainer.classList.add('d-block');

				break;
			}

			// Not found, get next parent
			element = element.parentElement;
			parentsTraversed++;
		}
	}

	function displayExtendedErrorMessage(error) {
		const data = error.response.data;
		// noinspection JSUnresolvedVariable
		const customSwalSettings = data.swalSettings ? data.swalSettings : {};

		const swalSettings = {
			icon: 'error',
			title: data.title,
			html: data.html,
		};


		const finalSwalSettings = {
			...swalSettings,
			...customSwalSettings
		}

		// noinspection JSCheckFunctionSignatures
		Swal.fire(finalSwalSettings);
	}
}

